/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import GlobalStyle from '../styles/_globals/globalStyles'
import { Header } from "./Header"
import { Footer } from "./Footer"
import "../styles/_layout.scss"
import { FacebookProvider } from 'react-facebook';

const Layout = ({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `)

  return (
    <>
      <GlobalStyle />
      <Header siteTitle={`Grupo W`} />
      <FacebookProvider appId="301867941176878">
        <div>
          <main>{children}</main>
        </div>
      </FacebookProvider>
      
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
